import React from 'react';
import UserProfile from 'containers/Sidebar/UserProfile';
import FirebaseAuth from 'firebase/firebaseAuth';

const UserInfo = () => {
  return <UserProfile onSignOut={FirebaseAuth.signOut} mode="compact" />;
};

export default UserInfo;
